import React from 'react';
import { useEffect } from 'react';
import 'src/uglib_styles/serviceHours.module.css'

function ServiceHours (props) {

	useEffect(() => {

		if (window.jQuery) {
			const jQuery = window.jQuery;
			const $ = window.jQuery;

			// This mess of code comes from SpringShare
			(function(a) {
				a.LibCalWeeklyGrid = function(s, n) {
					var r = {
							iid: 0,
							lid: 0,
							systemTime: !1
						},
						l = this;
					l.settings = {};
					var c = function(e, i, s, n, t) {
						var r = null === t ? "" : "&date=" + t,
							a = n ? "&systemTime=1" : "";
						jQuery.ajax({
							type: "get",
							dataType: "jsonp",
							jsonpCallback: "s_lc_hours_grid_cb_" + s,
							cache: !0,
							url: "https://api3-ca.libcal.com/widget/hours/grid?weeks=52&iid=" + l.settings.iid + "&lid=" + s + a + r
						}).done(function(t) {
							l.el.html(t);
							jQuery("#s-lc-whw-next-" + s + ", #s-lc-whw-prev-" + s).on("click", function() {
								hide_table();
								var t = jQuery(this).data("date");
								after_pager();
								c(e, i, s, n, t);
							});
						})
					};
					function f() {
						l.settings = a.extend({}, r, n);
						l.el = s;
						if (0 === l.settings.iid) 
							return l.el.text("IID is not setup!");
						var t = a('script[src*="libcal"][src*="hours_grid.js"]').attr("src");
						let e = document.createElement("a");
						e.href = t;
						var i = "https://" + e.hostname;
						c(i, l.settings.iid, l.settings.lid, l.settings.systemTime, null)
					}
					f();
				}
			})(jQuery);

			/*
			* If a location contains no times (.s-lc-time) then hide it.
			* If there are no locations loaded, this function schedules itself to be called again. 
			* This happens when the function is called before the locations are loaded. 
			*/
			function hide_locations() {
				var locations = document.querySelectorAll('tr.s-lc-whw-subloc');
				if (locations.length) {
					locations.forEach(function(location) {
						let times = location.querySelectorAll('.s-lc-time');
						if(times.length === 0) {
							location.classList.add('hidden');
						}
					})
				} else {
					setTimeout(hide_locations, 150);
					setTimeout(show_table, 100);
				}	
			}

			/*
			* Whenever a pager button is used, hide the locations that have no times.
			*/
			function after_pager() {
				setTimeout(hide_locations, 100);
				setTimeout(show_table, 100);
			}

			function hide_table() {
				// This cuts down on page flicker when paging.
				// It finds the current height of the table, explicitly the height to that, and hides overflow. 
				// The show_table function resets these values to their initial state.
				const target = document.getElementById('s-lc-whw1911');
				if(target) {
					const height = target.offsetHeight;
					const height_value = `${height}px`;

					target.style.height = height_value;
					target.style.overflow = 'hidden';
				}
				
				jQuery('#s-lc-whw-1-1911 .s-lc-whw-cont').css('display', 'none');
			}

			function show_table() {
				// This cuts down on page flicker when paging.
				// This resets the styles applied in the hide_table function.
				const target = document.getElementById('s-lc-whw1911');
				if(target) {
					target.style.height = 'auto';
					target.style.overflow = 'visible';
				}
				
				jQuery('#s-lc-whw-1-1911 .s-lc-whw-cont').css('display', 'initial');
			}
			  
			$.LibCalWeeklyGrid( $("#s-lc-whw1911"), { iid: 3228, lid: 1911, systemTime: true }); 
			hide_locations();

		}
	});

	return (<>
		<div id="s-lc-whw1911"></div>
	</>)
}

export default ServiceHours